import { theme } from '../constants/defaults';

// Returns the number of optional product details to be shown,
// values of the detailsList need to be boolean.
export function getDetailsCount() {
  const detailsList = [theme.settings.searchShowPrice, theme.settings.searchShowVendor];

  const detailsCount = detailsList.reduce((acc, detail) => acc + (detail ? 1 : 0), 0);

  return detailsCount;
}

export function getNumberOfResultsString(resultNumber, resultsCount) {
  return theme.strings.number_of_results
    .replace('[result_number]', resultNumber)
    .replace('[results_count]', resultsCount);
}
